/**
 * The assistant's mark: a generic 4-point sparkle, independent of
 * `~/components/icons/LogoIcon`, so rebranding the product logo never has to
 * touch this file.
 *
 * It is monochrome: it takes its surface's text colour (`currentColor`), on
 * every surface and in both themes. The brand gradient it used to carry is
 * gone with Langy's own palette (docs/design-system/DEVIATIONS.md, D-10).
 */

// The mark's natural proportions: a square sparkle glyph (Lucide's
// "sparkles" icon, the same generic "AI" glyph most products ship).
const MARK_VIEWBOX_WIDTH = 24;
const MARK_VIEWBOX_HEIGHT = 24;

const MARK_PATH =
  "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .962 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.964 0z";

/**
 * @deprecated The mark is monochrome and needs no paint server. Renders
 * nothing; kept so the command bar and the AI create modal (outside this
 * feature) still compile until they drop it.
 */
export function LangyMarkGradientDefs(_props: { id?: string }) {
  return null;
}

/**
 * The assistant's sparkle glyph in the current text colour. `size` is the
 * mark's HEIGHT in px; the glyph is square, so width equals size.
 * `gradientId` is accepted and ignored (see `LangyMarkGradientDefs`).
 */
export function LangyMark({
  size = 20,
}: {
  size?: number;
  gradientId?: string;
}) {
  const width = (size * MARK_VIEWBOX_WIDTH) / MARK_VIEWBOX_HEIGHT;
  return (
    <svg
      className="langy-mark"
      width={width}
      height={size}
      viewBox={`0 0 ${MARK_VIEWBOX_WIDTH} ${MARK_VIEWBOX_HEIGHT}`}
      fill="none"
      aria-hidden
    >
      <path fill="currentColor" d={MARK_PATH} />
    </svg>
  );
}
